import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { localStorage } from '@mdc/services';
import PropTypes from 'prop-types';
import { NOTIFICATION_TYPES } from '@mdc/constants';
import { NotificationContext } from '@mdc/ui';
import { StatusPageService, logService } from '@mdc/services';

const INCIDENT_ID = 'incidentId';

const StatusNotification = ({ children }) => {
    const { t, ready } = useTranslation();
    const { notify } = useContext(NotificationContext);
    const [incidentID, setIncidentID] = useState(localStorage.getItem(INCIDENT_ID) || '');

    const handleClick = () => {
        localStorage.setItem(INCIDENT_ID, `${localStorage.getItem(INCIDENT_ID)}-dismissed`);
    };

    if (!ready) {
        return null;
    }

    useEffect(() => {
        (async () => {
            try {
                const newIncidentID = await StatusPageService.getIncident();
                if (newIncidentID && newIncidentID !== incidentID) {
                    setIncidentID(newIncidentID);
                }
            } catch (err) {
                logService.error(err);
            }
        })();

        if (incidentID && incidentID?.split('-')[1] !== 'dismissed') {
            notify({
                // eslint-disable-next-line no-useless-escape
                message: t('We are experiencing issues with our service. Check <a href=\"https://trust.opswat.com\" rel=`noopener noreferrer` target=`_blank`>our status page</a> for details'),
                type: NOTIFICATION_TYPES.INFO,
                alwaysVisible: true,
                handleClick: handleClick
            });
        }
    }, [incidentID]);

    return <>
        { children }
    </>;
};

StatusNotification.propTypes = {
    children: PropTypes.node
};

export default StatusNotification;
